import React, { useEffect, useState, useMemo } from "react";
import { getSessionData } from "../utils/auth";
import NavHeader from "../components/navigation/NavHeader";
import Footer from "../components/navigation/Footer";
import GoUpDown from "../components/navigation/GoUpDown";
import ForumHeaderSection from "../components/forum/ForumHeaderSection";
import PostListItem from "../components/post/PostListItem";
import labData from "../utils/labData";
import Pagination from "../components/pagination/Pagination";
import Breadcrumb from "../components/navigation/Breadcrumb";
import AsideLeft from "../components/aside/AsideLeft";
import AsideRight from "../components/aside/AsideRight";
import { useParams } from "react-router-dom";
import TruckIcon from "../components/icons/Truck";
import { Utils } from "../utils";
import OrderByDescending from "../components/icons/OrderByDescending";
import OrderByAscending from "../components/icons/OrderByAscending";
import { getForum, getCommunityBudges, getCommunity } from "../core/communities";
import ForumSkeleton from "../components/skeletons/ForumSkeleton";
import Loader from 'react-loaders';
import ForumAvatar from "../components/forum/ForumAvatar";
import { useNavigate } from "react-router-dom";
import EditIcon from "../components/icons/Edit";
import AdIcon from "../components/icons/Ad";
import PlusCircle from "../components/icons/PlusCircle";
import ReactTimeAgo from 'react-time-ago';
import LoginAlertModal from "../components/auth/LoginAlertModal";
import MainLayout from "../components/layouts/MainLayout";
import CommunityLayout from "../components/layouts/CommunityLayout";
import PostPreview from "../components/post/PostPreview";
import { pinPost, unPinPost } from "../core/communities";
import { usePageTitle } from '../hooks/usePageTitle';
import toast from 'react-hot-toast';
import { POST_VIEWED_CHANGED, removePostFromCommunityBadges } from "../utils/postsViewed";

const Forum = () => {
    usePageTitle('Forum - Wefayo');
    const { comid, id } = useParams();
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [forum, setForum] = useState(null);
    const [postsToRender, setPostsToRender] = useState([]);
    const [isDescOrder, setIsDescOrder] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isOrderLoading, setIsOrderLoading] = useState(false);
    const [breadcrumbPages, setBreadcrumbPages] = useState([]);
    const [communityBudges, setCommunityBudges] = useState({});
    const [community, setCommunity] = useState(null);
    const [pinErrors, setPinErrors] = useState([]);
    const [isPinLoading, setIsPinLoading] = useState(false);
    const [postIdToPin, setPostIdToPin] = useState(null);

    let loggedInUser = getSessionData();
    let role = loggedInUser?.role ?? "";


    const setPinnedPostsFirst = (posts) => {
        let pinned = [];
        let others = [];
        posts.forEach((post) => {
            if (post.is_pinned && post.is_pinned === true) {
                pinned.push(post);
            } else {
                others.push(post);
            }
        });
        return pinned.concat(others);
    }

    const handlePinPost = async (e, postId) => {
        e.preventDefault();
        setPinErrors([]);
        setIsPinLoading(true);
        const inputs = {
            id: postId
        };
        let response = null;
        response = await pinPost(inputs);
        setIsPinLoading(false);
        if (response !== true) {
            return setPinErrors(response);
        }
        toast.success('Post was pinned successfully', {
            icon: '✅'
        });
        onPinPostChanged(postId);
    }

    const handleUnPinPost = async (e, postId) => {
        e.preventDefault();
        setPinErrors([]);
        setIsPinLoading(true);
        const inputs = {
            id: postId
        };
        let response = null;
        response = await unPinPost(inputs);
        setIsPinLoading(false);
        if (response !== true) {
            return setPinErrors(response);
        }
        toast.success('Post was unpinned successfully', {
            icon: '✅'
        });
        onPinPostChanged(postId);
    }

    const fetchForum = async (isOrderChange) => {

        // const cm = await getCommunity(comid);

        // console.log("@A");

        let communityBudges = {};
        if (loggedInUser !== null) {
            communityBudges = await getCommunityBudges();
        }
        setCommunityBudges(communityBudges);

        if (isOrderChange === false) {
            setIsLoading(true);
        } else {
            setIsOrderLoading(true)
        }
        const order = isDescOrder ? "asc" : "desc";
        const data = await getForum(id, order);

        //order posts by pinned first: posts
        data.posts = setPinnedPostsFirst(data.posts);

        setForum(data);
        setIsLoading(false);
        setIsOrderLoading(false)
        setIsDescOrder(!isDescOrder);


        setBreadcrumbPages([
            { name: data?.community.title, href: `/community/${comid}`, current: false },
            { name: data?.title, href: `/community/${comid}/forum/${id}`, current: true },
        ]);


        // console.log("@D");

        // setCommunity(cm);

    }


    useEffect(() => {
        fetchForum(false);
    }, []);

    useEffect(() => {
        const handlePostViewed = (event) => {
            const postId = event?.detail?.postId;
            const forumId = event?.detail?.forumId;
            if (postId == null || postId === '' || forumId !== id) {
                return;
            }
            setCommunityBudges((prev) => removePostFromCommunityBadges(prev, forumId, postId));
        };
        window.addEventListener(POST_VIEWED_CHANGED, handlePostViewed);
        return () => window.removeEventListener(POST_VIEWED_CHANGED, handlePostViewed);
    }, [id]);


    let data = {
        length: forum ? forum.posts.length : 0
    };
    let PageSize = labData.pageSize;




    const handleChangeOrder = (e) => {
        e.preventDefault();
        fetchForum(true);
    }

    const handleAddNewPostClick = (e, comid, id) => {
        e.preventDefault();
        if (loggedInUser !== null) {
            navigate(`/forum-post-form/${comid}/${id}`);
        } else {
            toggleLoginAlertModalModal();
            // navigate(`/login`);
        }
    }

    const onPinPostChanged = (postId) => {
        fetchForum();
    }

    const [isLoginAlertModalOpen, setIsLoginAlertModalOpen] = useState(false);
    const toggleLoginAlertModalModal = () => {
        setIsLoginAlertModalOpen(!isLoginAlertModalOpen);
    };

    let showLatestPostTimeAgo = false;
    if (forum?.latest_post) {
        const pstDate = forum?.latest_post?.date_of_post ?? "";
        if (pstDate.length > 0) {
            const threeWeeksAgo = Date.now() - 3 * 7 * 24 * 60 * 60 * 1000;
            const pstTimestamp = new Date(pstDate).getTime();
            showLatestPostTimeAgo = pstTimestamp > threeWeeksAgo
        }
    }


    const handleClickUserProfile = (userId) => {
        if (loggedInUser !== null) {
            navigate(`/profile/${userId}`);
        } else {
            toggleLoginAlertModalModal();
        }
    }



    const onCommunitiesLoaded = (communities, loggedInUser,) => {
        // if(Array.isArray(communities) && communities.length > 0){
        //     setDisplayedCommunities(communities);
        //     setLoggedInUser(loggedInUser);
        // }
    }

    return (

        <CommunityLayout currentPage={"forum"} onCommunitiesLoaded={onCommunitiesLoaded} >
            {isLoading &&
                <ForumSkeleton></ForumSkeleton>
            }

            {!isLoading &&
                <div className="flex-grow flex flex-col  ">
                    <LoginAlertModal message="Login to post." isOpen={isLoginAlertModalOpen} closeFun={setIsLoginAlertModalOpen} />
                    <ForumHeaderSection
                        forum={forum}
                        breadcrumbPages={breadcrumbPages}
                    />
                    {forum && <>
                        <div className="flex flex-col bg-primary-white p-3 mb-0 border-b border-gray-100 w-full">
                            <div className="mt-1  flex flex-row">
                                <div className="min-w-[48px] min-h-[48px] w-[48px] h-[48px] bg-purple-800x flex justify-center items-center text-purple-300 font-bold">
                                    <ForumAvatar forum={forum} />
                                </div>
                                <div className="pl-2 flex flex-col">
                                    <div className="text-left text-xl font-bold text-gray-800 ">
                                        {forum.title}
                                    </div>
                                    {forum.description && forum.description.length > 0 &&
                                        <div className="text-left text-gray-600 text-sm font-normal">
                                            {forum.description}
                                        </div>
                                    }
                                    {forum?.latest_post &&
                                        <div className="text-left text-gray-600 text-sm font-sans">
                                            {showLatestPostTimeAgo && <span className="mr-1">Latest post </span>}
                                            {/*by <a className="underline-offset-4 mr-1">{forum?.latest_post?.user.username},</a> */}
                                            {showLatestPostTimeAgo && <ReactTimeAgo date={forum?.latest_post?.date_of_post} locale="en-US" />}
                                            {/* <span className="mr-3">,</span> on */}
                                            {/* <i className=" underline-offset-4 ml-1" >{Utils.formatDate(forum?.latest_post?.date_of_post, "month date, year")}</i> */}

                                            {/* <a
                                                href={`/community/${comid}/forum/${id}/post/${forum?.latest_post.post_id}`}
                                                className="underlinex text-purple-900  ml-1">
                                                - {forum?.latest_post?.title}
                                            </a> */}
                                        </div>
                                    }
                                </div>
                            </div>

                        </div>

                        <div className="flex justify-between mb-0  bg-white p-2 border-b border-gray-100 ">
                            <h1 className="font-bold text-md md:text-xl flex items-center">
                                <span className="isolate inline-flex rounded-sm ">
                                    <button role="button" aria-label="toggle order of posts ascending or descending" onClick={handleChangeOrder} type="button" className="relative inline-flex items-center rounded-sm bg-gray-300x px-0 md:px-2 mr-1 py-0.5 font-semibold text-purple-900 hover:bg-gray-200 ">
                                        {isDescOrder &&
                                            <OrderByDescending />
                                        }
                                        {!isDescOrder &&
                                            <OrderByAscending />
                                        }
                                    </button>
                                </span>
                                Posts

                            </h1>

                            <div className="flex flex-row">
                                <a
                                    onClick={(e) => handleAddNewPostClick(e, comid, id)}
                                    className="pointer flex flex-row gap-x-[2px] cursor-pointer rounded-sm text-purple-900 px-3 py-1.5 text-sm md:text-md font-bold hover:text-purple-800 "
                                >
                                    <PlusCircle />
                                    Create Post
                                </a>
                                {loggedInUser?.role === "admin" &&
                                    <>
                                        <a
                                            href={`/community/${comid}/forum/${id}/edit`}
                                            className="pointer flex flex-row gap-x-[2px]  cursor-pointer ml-2 rounded-sm text-purple-900 px-3 py-1.5 text-sm md:text-md font-bold hover:text-purple-800 "
                                        >
                                            <EditIcon />
                                            Edit
                                            <span className="hidden md:inline-block">Forum</span>
                                        </a>

                                        <a
                                            href={`/forumads/add/${id}`}
                                            className="pointer flex flex-row items-center gap-x-[2px]  cursor-pointer ml-2 rounded-sm text-purple-900 px-3 py-1.5 text-sm md:text-md font-bold hover:text-purple-800 "
                                        >
                                            <AdIcon />
                                            Create Ad
                                        </a>
                                    </>
                                }
                            </div>

                        </div>


                        <div className="flex flex-col min-h-[55%]  items-start w-full bg-gray-100 p-2 gap-y-2 ">
                            {isOrderLoading &&
                                <div className="w-full flex justify-center ">
                                    <Loader type="ball-beat" style={{ transform: 'scale(0.5)' }} />
                                </div>
                            }

                            {forum.posts.map((post, index) => (
                                // <PostListItem 
                                //     postBudges={communityBudges[id] ? communityBudges[id] : []} 
                                //     post={post} key={index} 
                                //     communityId={comid} 
                                //     forumId={id} 
                                //     onPinPostChanged={onPinPostChanged} 
                                //     role={role} 
                                //     handleClickUserProfile={handleClickUserProfile} />

                                <div className="flex flex-col text-sm items-left block w-full ">
                                    <PostPreview
                                        parentIndex={index}
                                        handlePreviewHover={() => { }}
                                        postBudges={communityBudges[id] ? communityBudges[id] : []}
                                        community={{
                                            _id: forum.community._id,
                                        }}
                                        forum={{
                                            pinned_post: {
                                                post_id: post._id,
                                                media: post.media,
                                                title: post.title,
                                                details: post.summary,
                                                date_of_post: post.createdAt,
                                                user: post.user,
                                                likes: post.likes,
                                                count_of_replies: post.count_of_replies,
                                            },
                                            _id: forum._id,
                                        }}
                                        isPinned={forum?.pinned_post?.post_id === post._id}
                                        context="forum"
                                        handleClickUserProfile={() => { }} />

                                    {role === "admin" &&
                                        <div className="pb-1 flex justify-end w-full">
                                            {(forum?.pinned_post?.post_id !== post._id) &&
                                                <button role="button"
                                                    onClick={(e) => { e.stopPropagation(); setPostIdToPin(post._id); handlePinPost(e, post._id) }}
                                                    className="flex items-center justify-center rounded-sm bg-purple-900 hover:bg-purple-800 p-1 min-w-[100px] w-fit text-xs font-semibold  text-white active:text-white/80 btn-gradient-main cursor-pointer" >
                                                    {(isPinLoading && post._id == postIdToPin) && <Loader type="ball-beat" style={{ transform: 'scale(0.5)' }} />}
                                                    Pin Post
                                                </button>
                                            }

                                            {(forum?.pinned_post?.post_id === post._id) &&
                                                <button role="button"
                                                    onClick={(e) => { e.stopPropagation(); setPostIdToPin(post._id); handleUnPinPost(e, post._id) }}
                                                    className="flex items-center justify-center rounded-sm bg-purple-900 hover:bg-purple-800 p-1 min-w-[100px] w-fit text-xs font-semibold  text-white active:text-white/80 btn-gradient-main cursor-pointer" >
                                                    {(isPinLoading && post._id == postIdToPin) && <Loader type="ball-beat" style={{ transform: 'scale(0.5)' }} />}
                                                    Unpin Post
                                                </button>
                                            }
                                        </div>
                                    }
                                </div>

                            ))}

                            {forum.posts.length == 0 &&
                                <div className="flex justify-center py-12 text-gray-400 font-semibold lg:py-20 bg-white w-full" >
                                    <div className="flex flex-col items-center text-xs sm:text-sm md:text-base">
                                        <div>
                                            No Posts
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>


                        <div className="py-1 mb-5 text-sm ">
                            <Pagination
                                id="pgn-bottom"
                                currentPage={currentPage}
                                totalCount={data.length}
                                pageSize={PageSize}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                    </>}
                </div>
            }

        </CommunityLayout>
    );
};

export default Forum;